import React from 'react';
import './Features.scss';

export const Features = () => {
  const features = [
    {
      icon: '🌐',
      title: 'Global Communities',
      description: 'Connect with learners and teachers from around the world in diverse communities.',
      color: '#6366f1'
    },
    {
      icon: '📚',
      title: 'Interactive Courses',
      description: 'Access high-quality courses with interactive content, quizzes, and assignments.',
      color: '#8b5cf6'
    },
    {
      icon: '🎥',
      title: 'Live Classes',
      description: 'Join live virtual classrooms with real-time interaction and screen sharing.',
      color: '#ec4899'
    },
    {
      icon: '👥',
      title: 'One-on-One Tutoring',
      description: 'Book private sessions with expert tutors for personalized learning.',
      color: '#f59e0b'
    },
    {
      icon: '📅',
      title: 'Event Management',
      description: 'Create and join educational events, workshops, and webinars.',
      color: '#10b981'
    },
    {
      icon: '💬',
      title: 'Real-time Chat',
      description: 'Stay connected with instant messaging, voice, and video calls.',
      color: '#3b82f6'
    },
    {
      icon: '📊',
      title: 'Progress Tracking',
      description: 'Monitor your learning progress with detailed analytics and reports.',
      color: '#06b6d4'
    },
    {
      icon: '🎓',
      title: 'Certificates',
      description: 'Earn certificates upon course completion to showcase your achievements.',
      color: '#8b5cf6'
    },
    {
      icon: '💰',
      title: 'Monetization',
      description: 'Teachers can earn by creating courses, hosting classes, and building communities.',
      color: '#22c55e'
    },
    {
      icon: '🔒',
      title: 'Secure Payments',
      description: 'Safe and secure payment processing with multiple payment options.',
      color: '#ef4444'
    },
    {
      icon: '📱',
      title: 'Mobile Apps',
      description: 'Learn on the go with our iOS and Android mobile applications.',
      color: '#6366f1'
    },
    {
      icon: '🌟',
      title: 'Verified Badges',
      description: 'Get verified to build trust and credibility in the community.',
      color: '#f59e0b'
    }
  ];

  return (
    <div className="features-page">
      {/* Hero Section */}
      <section className="hero-section text-center py-5">
        <div className="container">
          <h1 className="display-4 fw-bold mb-4" data-aos="fade-up">
            Powerful Features for <span className="text-theme1">Learning</span>
          </h1>
          <p className="lead text-muted mb-5 mx-auto" style={{ maxWidth: '700px' }} data-aos="fade-up" data-aos-delay="100">
            Discover all the tools and features that make Yoospeak the perfect platform for online learning and teaching.
          </p>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-grid py-5">
        <div className="container">
          <div className="row g-4">
            {features.map((feature, index) => (
              <div className="col-12 col-md-6 col-lg-4" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="feature-card card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div 
                      className="feature-icon mb-3"
                      style={{ backgroundColor: `${feature.color}15` }}
                    >
                      <span style={{ fontSize: '2.5rem' }}>{feature.icon}</span>
                    </div>
                    <h4 className="card-title fw-bold mb-3">{feature.title}</h4>
                    <p className="card-text text-muted">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold mb-5" data-aos="fade-up">How It Works</h2>
          <div className="row g-5">
            <div className="col-12 col-md-4" data-aos="fade-up" data-aos-delay="0">
              <div className="text-center">
                <div className="step-number mx-auto mb-4">1</div>
                <h4 className="fw-bold mb-3">Sign Up</h4>
                <p className="text-muted">
                  Create your free account and set up your profile in minutes.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4" data-aos="fade-up" data-aos-delay="100">
              <div className="text-center">
                <div className="step-number mx-auto mb-4">2</div>
                <h4 className="fw-bold mb-3">Explore</h4>
                <p className="text-muted">
                  Browse communities, courses, and connect with teachers.
                </p>
              </div>
            </div>
            <div className="col-12 col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="text-center">
                <div className="step-number mx-auto mb-4">3</div>
                <h4 className="fw-bold mb-3">Learn & Grow</h4>
                <p className="text-muted">
                  Start learning, teaching, and growing your knowledge network.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section py-5 text-center text-white">
        <div className="container">
          <h2 className="display-5 fw-bold mb-4" data-aos="fade-up">
            Ready to Get Started?
          </h2>
          <p className="lead mb-5" data-aos="fade-up" data-aos-delay="100">
            Join thousands of learners and teachers on Yoospeak today.
          </p>
          <div className="d-flex gap-3 justify-content-center flex-wrap" data-aos="fade-up" data-aos-delay="200">
            <button className="btn btn-light btn-lg px-5 rounded-pill">
              Start Learning
            </button>
            <button className="btn btn-outline-light btn-lg px-5 rounded-pill">
              Become a Teacher
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};
